import React, { useState, useEffect } from "react";
import { Col, Select } from "antd";

const { Option } = Select;

const AreaFilter = ({
  data,
  selectedZone,
  setSelectedZone,
  selectedSection,
  setSelectedSection,
  selectedStreet,
  setSelectedStreet,
  selectedLine,
  setSelectedLine,
}) => {
  const [sections, setSections] = useState([]);
  const [streets, setStreets] = useState([]);
  const [lines, setLines] = useState([]);

  useEffect(() => {
    if (selectedZone) {
      const zone = data.find((zone) => zone.id === selectedZone);
      setSections(zone ? zone.sections : []);
    } else {
      setSections([]);
    }
    setSelectedSection(null);
    setStreets([]);
    setSelectedStreet(null);
    setLines([]);
    setSelectedLine(null);
  }, [selectedZone, data]);

  useEffect(() => {
    if (selectedSection) {
      const section = sections.find(
        (section) => section.id === selectedSection
      );
      setStreets(section ? section.streets : []);
    } else {
      setStreets([]);
    }
    setSelectedStreet(null);
    setLines([]);
    setSelectedLine(null);
  }, [selectedSection, sections]);

  useEffect(() => {
    if (selectedStreet) {
      const street = streets.find((street) => street.id === selectedStreet);
      setLines(street ? street.lines : []);
    } else {
      setLines([]);
    }
    setSelectedLine(null);
  }, [selectedStreet, streets]);

  return (
    <>
      <Col xs={24} sm={12} md={4}>
        <Select
          placeholder="Filtrer par Contrat"
          style={{ width: "100%" }}
          onChange={(value) => setSelectedZone(value)}
          value={selectedZone}
          allowClear
        >
          {data.map((zone) => (
            <Option key={zone.id} value={zone.id}>
              {zone.name}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <Select
          placeholder="Filtrer par Zone"
          style={{ width: "100%" }}
          onChange={(value) => setSelectedSection(value)}
          value={selectedSection}
          disabled={!selectedZone}
          allowClear
        >
          {sections.map((section) => (
            <Option key={section.id} value={section.id}>
              {section.name}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <Select
          placeholder="Filtrer par Rue"
          style={{ width: "100%" }}
          onChange={(value) => setSelectedStreet(value)}
          value={selectedStreet}
          disabled={!selectedSection}
          allowClear
        >
          {streets.map((street) => (
            <Option key={street.id} value={street.id}>
              {street.name}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <Select
          placeholder="Filtrer par ligne"
          style={{ width: "100%" }}
          onChange={(value) => setSelectedLine(value)}
          value={selectedLine}
          disabled={!selectedStreet}
          allowClear
        >
          {lines.map((line) => (
            <Option key={line.id} value={line.id}>
              {line.name}
            </Option>
          ))}
        </Select>
      </Col>
    </>
  );
};

export default AreaFilter;
